module.exports = __webpack_public_path__ + "img/jin.0a11350a.png";